import React from 'react';
import { useFusionAuth } from '@fusionauth/react-sdk';
import { Navigate } from 'react-router-dom';
import './LoginPage.scss';
import iflogo from './assets/intellifire_logo.png';
import emlogo from './assets/easymap_logo.png';
import { getEnvironmentTitle } from './services/configService';
const version = import.meta.env.VITE_APP_VERSION || 'dev';
const buildTimeRaw = import.meta.env.VITE_APP_BUILD_TIME || '';
const buildTimeDisplay = buildTimeRaw
  ? new Date(buildTimeRaw).toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    })
  : '';

const LoginPage: React.FC = () => {
  const { isLoggedIn, isFetchingUserInfo, startLogin } = useFusionAuth();

  if (isFetchingUserInfo) {
    return <p>Loading...</p>;
  }

  if (isLoggedIn) {
    return <Navigate to="/map" replace />;
  }

  // Set background color based on the environment
  const getEnvironmentColor = (env: string): string => {
    switch (env?.toLowerCase()) {
      case 'prod':
      case 'production':
        return '#6786edff'; // blue
      case 'uat':
      case 'testing':
        return '#c47206ff'; // orange
      case 'staging':
        return '#0d9d0dff'; // green
      case 'localdev':
      case 'development':
      case 'dev':
        return '#cbcb0aff'; // yellow
      default:
        return '#6c0927ff'; // default to dark red
    }
  };

  const envTitle = getEnvironmentTitle();
  const environmentColor = getEnvironmentColor(envTitle);
  const enterpriseName = `IntelliFire`;
  const applicationName = `EasyMap 3`;
  console.log(`Environment: ${envTitle}`);

  const getInstanceLabel = (env: string): string => {
    switch (env?.toLowerCase()) {
      case 'prod':
      case 'production':
        return 'Production Instance';
      case 'uat':
      case 'testing':
        return 'UAT/Testing Instance';
      case 'staging':
        return 'Staging Instance';
      case 'localdev':
      case 'development':
      case 'dev':
        return 'Local Dev Instance';
      default:
        return 'Unknown Instance';
    }
  };

  const instance = getInstanceLabel(envTitle);
  return (
    <div className="login-container" style={{ backgroundColor: environmentColor }}>
      <div className="login-card">
        <div className="overlay-container">
          <img src={emlogo} alt="EasyMap Logo" className="emlogo" />
          <img src={iflogo} alt="IntelliFire Logo" className="iflogo-overlay" />
        </div>
        <div className="welcome-message">
          {applicationName}
          <div className="app-version">{version}</div>
          {buildTimeDisplay && <div className="app-build-time">Released {buildTimeDisplay}</div>}
          <h3>{instance}</h3>
          <hr />
          Powered By:{enterpriseName}
        </div>


        <button className="login-button" onClick={() => startLogin()}>Login</button>

      </div>
    </div>
  );
};

export default LoginPage;
